import React from 'react';
import Logo from './Logo';

const AppLoader = () => {
  return (
    <div style={{ top: '50%', left: '50%', position: 'absolute', marginTop: '-70px', marginLeft: '-100px' }}>
      <Logo width={200} />
    </div>
  );
};

export default AppLoader;
